<template lang="html">
  <div class="custom-header">
    <img src="./img/clock.png" alt="">
    <h1>
      <slot></slot>
    </h1>
    <p>亲爱的小主，我们默认推送时间是每天早上7:00哦~</p>
    <p>您可以自主选择课程更新提醒推送时间，获取为您量身</p>
    <p>定制的学习计划~~</p>
  </div>
</template>

<script>
export default {
  name: 'CustomTimeHeader'
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.custom-header {
  text-align: center;
  padding-top: rem(50);
  padding-bottom: rem(50);
  line-height: 1.4;
  img {
    width: rem(211);
    margin-bottom: rem(26);
  }
  h1 {
    font-size: rem(40);
    color: #333;
    margin-bottom: rem(16)
  }
  p {
    font-size: rem(24);
    color: #999999;
    line-height: 1.5;
  }
}
</style>
